import React from "react";
import { helpModes } from "../data/framework";
const cellBorders = ["", "sm:border-l sm:pl-8", "lg:border-l lg:pl-8", "sm:border-l sm:pl-8"];
export function HowWeHelp() {
  return <section aria-labelledby="how-we-help" className="bg-oxblood text-ivory" data-id="element-207" data-mp="10bvvyfcbav05">
      <div className="shell py-24 md:py-32" data-id="element-208" data-mp="109rue41vy831">
        <div className="grid grid-cols-12 gap-x-6 gap-y-8" data-id="element-209" data-mp="14c69qe6cippk">
          <div className="col-span-12 lg:col-span-3 lg:pt-3" data-id="element-210" data-mp="7mxbvcompis7">
            <p className="eyebrow text-ivory/75" data-id="element-211" data-mp="7oi24q3wufk9">How we help</p>
          </div>
          <div className="col-span-12 lg:col-span-9" data-id="element-212" data-mp="cn32qqn2r198">
            <h2 id="how-we-help" className="font-display text-[clamp(2.25rem,4.6vw,4rem)] leading-[1.05]" data-id="element-213" data-mp="gnn4k7ilet1p">
              Whatever state it’s in, we step in.
            </h2>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-ivory/80" data-id="element-214" data-mp="lgg7cpui3rb5">
              Rescue, Implement, Optimize, and Operate describe the situation you’re in — not separate products. Each
              applies to payroll and HR technology alike.
            </p>
          </div>
        </div>

        <ol className="mt-16 grid grid-cols-1 border-t border-ivory/30 sm:grid-cols-2 lg:grid-cols-4" data-id="element-215" data-mp="4goddoguspv3">
          {helpModes.map((m, i) => <li key={m.id} className={`flex flex-col border-b border-ivory/20 py-10 sm:pr-8 lg:border-b-0 border-ivory/20 ${cellBorders[i]}`} data-id="element-216" data-mp="3qtmuvow1ka0j" data-mpi={i}>
              <span className="text-xs tabular-nums tracking-[0.12em] text-ivory/60" data-id="element-217" data-mp="3gvqotbhyo59a">{m.number}</span>
              <h3 className="mt-4 whitespace-nowrap font-display text-[clamp(2.25rem,5vw,3rem)] uppercase leading-none tracking-[0.02em] lg:text-[clamp(1.875rem,2.9vw,3rem)]" data-id="element-218" data-mp="3cun6micfxx4w">
                {m.verb}
              </h3>
              <p className="mt-5 font-display text-xl italic leading-snug" data-id="element-219" data-mp="32x0ta0asidn1">{m.situation}</p>
              <p className="mt-4 text-[15px] leading-relaxed text-ivory/75" data-id="element-220" data-mp="164gz4vwq5ing">{m.line}</p>
              <ul className="mt-auto pt-8" data-id="element-221" data-mp="11547lxuwrnej">
                {m.examples.map(ex => <li key={ex} className="border-t border-ivory/20 py-2.5 text-sm text-ivory/85" data-id="element-222" data-mp="2vl2rqy4lrh6u">
                    {ex}
                  </li>)}
              </ul>
            </li>)}
        </ol>
      </div>
    </section>;
}